/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function(){
  $(".tab-heading").click(function(){
    $(".tab-heading").removeClass('active');
    $(this).addClass('active');
    var data_tab = $(this).attr('data-tab');
    $(".tab-conetnt").each(function(){
      var data_content = $(this).attr('data-content');
      if(data_tab == data_content){
        $(this).show();
      }else{
        $(this).hide();
      }
    });
  });
});